export default __webpack_public_path__ + "static/media/success.7d9e10d3.jpg";